const axios = require('axios')
const axiosHeader = require('./auth')
 // const qs = require('qs')
const {REVENUE_ANALYSIS_URL,COST_ANALYSIS_URL} = require('./url')

/*获取收益分析数据*/

function getRevenueAnalysisData(dateObj){
    return new Promise((resolve, reject) => {
        axiosHeader.axiosStop()
        axios.get(REVENUE_ANALYSIS_URL,{
            params:{
                endDate: dateObj.endDate,
                startDate: dateObj.startDate
            }
        })
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}

/*获取成本分析数据*/
function getCostAnalysisData(dateObj){
    return new Promise((resolve, reject) => {
        axiosHeader.axiosStop()
        // console.log(dateObj);
        axios.get(COST_ANALYSIS_URL,{
            params:{
                endDate: dateObj.endDate,
                startDate: dateObj.startDate
            }
        })
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}

module.exports = {
    getRevenueAnalysisData,
    getCostAnalysisData
}
